import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
// import pc from "./components/pc-input-logic.vue";
// import mobile from "./components/mobile-input-logic.vue";
const info = {
    title: "表单标题",
    type: "formTitle",
    icon: "",
    dataItemType: DataItemType.ShortText,
    formControllerType: FormControlType.Title,
    group: "",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
    },
};
